var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"jackpot-page container"},[_c('div',{staticClass:"wrapper"},[_c('div',{class:[
        'frame',
        {
          'frame--jackpot-v2': _vm.isV2Jackpot,
        },
      ],style:({ transform: `scale(${_vm.frameScale})` })},[_vm._l((_vm.JACKPOTS),function(jackpot){return _c('Jackpot',{key:jackpot.name,attrs:{"name":jackpot.name,"currency":_vm.currency,"value":_vm.getJackpotByIndex(jackpot.code)}})}),_c('div',{staticClass:"jackpot__name jackpots__title"},[_vm._v(_vm._s(_vm.title))])],2),_c('div',{staticClass:"logo jackpots__logo"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }